import type { ClickOut } from '../ui/posts/types';

type MapsClickout = Pick<ClickOut, 'url' | 'type'>;

export const getMapsClickout = (clickouts?: MapsClickout[]): MapsClickout | undefined =>
    clickouts?.find((clickout) => clickout.type === 'map');
